const STORAGE_KEY = "app_version"

export function getStoredVersion(): string | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    return v ? String(v) : null
  } catch {
    return null
  }
}

export function setStoredVersion(version: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(version || ""))
  } catch {
    // ignore
  }
}

export function isNewVersion(currentVersion: string): boolean {
  const stored = getStoredVersion()
  if (!stored) return false
  return stored !== String(currentVersion || "")
}
